import { render } from "./PrcTest1CreateReadonly.vue?vue&type=template&id=4696b542&scoped=true"
import script from "./PrcTest1CreateReadonly.vue?vue&type=script&lang=js"
export * from "./PrcTest1CreateReadonly.vue?vue&type=script&lang=js"

import "./PrcTest1CreateReadonly.vue?vue&type=style&index=0&id=4696b542&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4696b542"]])

export default __exports__